/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_ApikeysInputs */

const en_directory_footer_link_apikeys = /** @type {(inputs: Directory_Footer_Link_ApikeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API keys`)
};

const zh_directory_footer_link_apikeys = /** @type {(inputs: Directory_Footer_Link_ApikeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 密钥`)
};

/**
* | output |
* | --- |
* | "API keys" |
*
* @param {Directory_Footer_Link_ApikeysInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_apikeys = /** @type {((inputs?: Directory_Footer_Link_ApikeysInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_ApikeysInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_apikeys(inputs)
	return zh_directory_footer_link_apikeys(inputs)
});
export { directory_footer_link_apikeys as "directory.footer.link_apikeys" }